module.exports = __webpack_public_path__ + "img/2.a9695313.jpg";